import React, { Component } from 'react';
import axios from 'axios';
import _capitalize from 'lodash/capitalize';
import _groupBy from 'lodash/groupBy';

import endpoints from '../../../../config/endpoints';

class DomansList extends Component {
	constructor(props) {
		super(props);
		this.state = { offer_domains_list: [] };
	}
	componentDidMount() {
		const { offer_id } = this.props;
		axios.get(`${endpoints.OFFERS.BASE}/${offer_id}/promo-attributes`)
			.then(data => this.setState({ offer_domains_list: data.data }));
	}

	render() {
		const { offer_domains_list } = this.state;
		const groupedByType = _groupBy(offer_domains_list, 'type');
		return (
			<p className="margin-top-30">
				{Object.entries(groupedByType).map(([key, val]) => <SubLists type={key} key={key} domains={val}/>)}
			</p>
		);
	}
}

const SubLists = ({ domains = [], type }) => {
	return (
		<p>
			<p className="bald-font margin-top-15 text-center">{_capitalize(type)}:</p>
			{domains
				.map((dom, index) =>
					<p key={index} className="margin-top-8 text-center">
						<a className="default-link" href={`http://${dom.domain}`} target="_blank">
							{dom.domain} { dom.is_authors_promo === 'true' && '*' }
						</a>
					</p>
				)
			}
		</p>
	);
};

export default DomansList;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table/domains-list.js